export default "__VITE_ASSET__C1__SvLD__"